// extracted by mini-css-extract-plugin
export var bodyText = "index-module--bodyText--yNNjt";
export var ctaContainer = "index-module--ctaContainer--U96Lh";
export var ctaWrapper = "index-module--ctaWrapper--7e39s";
export var ctas = "index-module--ctas--TMNke";
export var imageWrapper = "index-module--imageWrapper--gyS4W";
export var left = "index-module--left--pVKOp";
export var linkText = "index-module--linkText--Txnsq";
export var right = "index-module--right--YBz8g";
export var rightArrow = "index-module--rightArrow--XCvxt";
export var titleText = "index-module--titleText--sizwc";
export var twoThirdsCalloutContainer = "index-module--twoThirdsCalloutContainer--zgpXq";